// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"fd710c8c","522":"cc6c69f0","643":"0e02bb73","734":"a484f421","987":"446c62e4"}[chunkId] + ".chunk.js";
};